import { inject } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { Typography } from '~/components';
import { ThemeContext } from '~/contexts';
import { DashboardStore } from '~/stores';
import { findValueByLabelOnDeviceCardMetadata, info } from '~/utils';
import Dashboard from './Dashboard';

type Props = {
  dashboardStore?: DashboardStore;
};

const DashboardContainer: React.FC<Props> = ({ dashboardStore }) => {
  const {
    theme: { colors },
  } = useContext(ThemeContext);

  useEffect(() => {
    info(
      <Typography typographyProps={{ style: { color: colors.text?.darker } }}>
        This is the demo version project, all data that is being fetched was
        statically generated.
      </Typography>,
    );
  }, [colors]);

  if (!dashboardStore) return null;

  const {
    activeDevice: { device, metadata },
  } = dashboardStore;

  return (
    <Dashboard
      activeDeviceType={device}
      deviceId={findValueByLabelOnDeviceCardMetadata(
        'ID Dispositivo',
        metadata,
      )}
    />
  );
};

export default inject('dashboardStore')(DashboardContainer);
